var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeTariffOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.39 9.01001C42.78 18.58 31.61 24.64 19.44 25.82L18.5 25.91V53.97C18.5 65.1 24.21 75.55 33.82 81.99L50.39 93.09L66.96 81.99C76.57 75.55 82.28 65.11 82.28 53.97V25.91L81.34 25.82C69.17 24.65 58 18.58 50.39 9.01001Z",
    fill: "#5A87FF",
    stroke: "#5A87FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.49 62.5399C57.9735 62.5399 64.04 56.4734 64.04 48.9899C64.04 41.5065 57.9735 35.4399 50.49 35.4399C43.0065 35.4399 36.94 41.5065 36.94 48.9899C36.94 56.4734 43.0065 62.5399 50.49 62.5399Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1 43.0699C57.26 44.7499 48.72 54.8999 48.72 54.8999C48.72 54.8999 42.57 49.3299 41.89 48.5199",
    stroke: "#101C1E",
    strokeWidth: 1.58,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.68 79.21C27.01 73.4 21.84 63.97 21.84 53.96V28.89C32.76 27.36 42.82 22.14 50.39 14.1C57.96 22.14 68.02 27.36 78.94 28.89V53.96C78.94 63.96 73.77 73.4 65.1 79.21L50.39 89.07L35.68 79.21V79.21Z",
    stroke: "#4063B2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.21 36.49C76.21 36.49 76.21 21.7 91 21.7C91 21.7 76.21 21.7 76.21 6.91003C76.21 6.91003 76.21 21.7 61.42 21.7C61.42 21.7 76.21 21.7 76.21 36.49Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.24 91.51C17.24 91.51 17.24 83.27 25.48 83.27C25.48 83.27 17.24 83.27 17.24 75.03C17.24 75.03 17.24 83.27 9 83.27C9 83.27 17.24 83.27 17.24 91.51V91.51Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeTariffOffer);
export default __webpack_public_path__ + "static/media/change-tariff-offer.3f5a57202ea3531f4c6c076bde2da92a.svg";
export { ForwardRef as ReactComponent };